export enum PaymentStatusResponseStatus {
	Success = 'success',
	Cancelled = 'cancelled',
	Pending = 'pending',
	Unknown = 'unknown',
	// The card leg is paid or in flight but a Fritidskortet grant failed, so part of the order is still owed.
	RemainingDue = 'remaining_due',
}

export interface PaymentStatusResponse {
	organizationId: number;
	groupId: number;
	guid: string;

	/** @deprecated Use paymentStatus instead. */
	cancelled?: boolean;
	/** @deprecated Use paymentStatus instead. */
	success?: boolean;
	paymentStatus?: PaymentStatusResponseStatus;
	/** Seconds a pending payment is still treated as in flight; only on pending reads of a stored session. */
	graceRemainingSeconds?: number;
	/** Where the payer settles what is still owed; set with RemainingDue. */
	payRemainingUrl?: string;
}
